module.exports = __webpack_public_path__ + "img/doorpostBanner.78f86d3a.png";